// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@disy/cadenza-icons/dropdown-arrow-12x24.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * We cannot easily remove these global variables, because they're used in multiple places.
 *
 * PLEASE DO NOT ADD MORE VARIABLES HERE! (Unless they're used in multiple places, too.)
 */
:root {
  --button-size-m: 32px;
  --button-size-s: 24px;
}
@media (pointer: coarse) {
  :root {
    --button-size-m: 44px;
    --button-size-s: 32px;
  }
}
.button {
  --button-bg: var(--gray-01);
  --button-bg-active: var(--primary-color);
  --button-bg-disabled: var(--button-bg);
  --button-bg-hover: var(--gray-02);
  --button-color: var(--gray-08);
  --button-color-active: var(--white-09);
  --button-color-disabled: var(--disabled-color);

  align-items: center;
  appearance: none;
  background-color: var(--button-bg);
  border: none;
  color: var(--button-color);
  display: inline-flex;
  flex-shrink: 0;
  font-family: var(--default-font-family);
  font-size: var(--default-font-size);
  font-weight: var(--bold-font-weight);
  justify-content: center;
  outline: none;
  text-align: center;
  text-decoration: none;
  transition:
    background-color var(--default-transition),
    box-shadow var(--default-transition),
    color var(--default-transition);
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  width: fit-content; /* Do not stretch in column flex layouts */
}
.button::-moz-focus-inner {
    border: 0;
  }
.button:disabled {
    background-color: var(--button-bg-disabled);
    color: var(--button-color-disabled);
  }
.button:not(:disabled) {
    cursor: pointer;
  }
.button:hover:not(:disabled) {
    background-color: var(--button-bg-hover);
  }
.is-keynav .button:focus {
    border-radius: 1px;
    box-shadow: var(--default-outline);
    outline: var(--default-native-outline);
  }
:is(.button:active,.button.active,.button[aria-pressed='true'],.button[aria-expanded='true']):not(:disabled) {
      background-color: var(--button-bg-active);
      color: var(--button-color-active);
    }
.button:where(:not(.button-icon,.button-round)) > .d-icon:first-child {
    margin-right: 2px;
  }
.button .button--label {
    cursor: inherit;
  }
.button .button--label + .d-icon {
    margin-left: 4px;
  }
.light-bg .button {
  --button-bg: var(--white-09);
}
.dark-bg .button {
  --button-bg: var(--white-01);
  --button-bg-active: var(--white-09);
  --button-bg-disabled: var(--white-01);
  --button-bg-hover: var(--white-02);
  --button-color: var(--white-08);
  --button-color-active: var(--primary-color);
}
/*********
 * Sizes *
 *********/
/* Default Size (M) */
.button {
  --button-size: var(--button-size-m);
  --button-icon-size: 24px;
  --button-padding: 12px;

  height: var(--button-size);
  line-height: var(--button-size);
  min-width: calc(var(--button-size)*2);
  padding: 0 var(--button-padding);
}
.button > .d-icon,.button > .d-icon-stack,.button > .d-icon-stack > .d-icon {
    height: var(--button-icon-size);
    width: var(--button-icon-size);
  }
.button-s {
  --button-size: var(--button-size-s);
  --button-icon-size: 20px;
  --button-padding: 8px;
}
.button-xs {
  --button-size: 20px;
  --button-touch-size: calc(100% - var(--button-size) + var(--button-size-s));
  --button-icon-size: 16px;
  --button-padding: 4px;

  font-size: var(--small-font-size);
  position: relative;

  /* increase the size of the button's touch target without increasing the visual size */
}
.button-xs::before {
    content: '';
    display: block;
    height: var(--button-touch-size);
    position: absolute;
    width: var(--button-touch-size);
  }
@media (pointer: coarse) {
.button-xs {
    --button-size: 24px;
    --button-icon-size: 20px;
}
  }
/* Not an official button size */
.button-xxs {
  --button-size: 16px;
  --button-icon-size: 12px;
  --button-padding: 2px;
}
/***************
 * Icon Button *
 ***************/
.button-icon {
  --button-padding: 4px;

  min-width: 0;
  width: var(--button-size);
}
.button-icon.button-s {
    --button-padding: 0;
  }
.button-icon.button-xs {
    --button-padding: 1px;
  }
.button-icon.button-xxs {
    --button-padding: 2px;
  }
/************************
 * Button with dropdown *
 ************************/
.button-with-dropdown {
  --dropdown-arrow-width: 12px;
  --dropdown-arrow-color: currentColor;
}
.button-with-dropdown::after {
    background-color: var(--dropdown-arrow-color);
    content: '';
    display: inline-block;
    height: 24px;
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: var(--dropdown-arrow-width);
  }
:not(.button-icon):is(.button-with-dropdown::after) {
      margin-left: 4px;
    }
.button-icon.button-with-dropdown {
  width: calc(var(--button-size) + var(--dropdown-arrow-width)); /* Adds space for the dropdown */
}
/************
 * Variants *
 ************/
/* Primary */
.button.button-primary {
  --button-bg: var(--primary-color);
  --button-bg-active: var(--primary-color-darken-30);
  --button-bg-disabled: var(--gray-03);
  --button-bg-hover: var(--primary-color-darken-15);
  --button-color: var(--white-09);
  --button-color-active: var(--white-09);
  --button-color-disabled: var(--white-07);
}
.light-bg .button-primary {
  --button-color: var(--gray-01-opaque);
  --button-color-disabled: var(--gray-01-opaque);
}
.dark-bg .button-primary {
  --button-bg: var(--white-08);
  --button-bg-active: var(--white-09);
  --button-bg-disabled: var(--white-03);
  --button-bg-hover: var(--white-09);
  --button-color: var(--gray-08-opaque);
  --button-color-active: var(--primary-color);
  --button-color-disabled: var(--white-04);
}
/* Borderless */
.button.button-borderless {
  --button-bg: transparent;
  --button-bg-active: var(--gray-02);
  --button-bg-hover: var(--gray-01);
  --button-color: var(--gray-06);
  --button-color-active: var(--primary-color);

  min-width: var(--button-size);
}
.button.button-borderless:not(.button-icon) {
    --button-padding: 2px;
  }
.button-borderless.button-with-dropdown:not(:disabled) {
  --dropdown-arrow-color: #6d7177;
}
.button-borderless.button-error {
    --button-color: var(--color-error);
    --button-color-active: var(--color-error-dark);
  }
.button-borderless.button-warning {
    --button-color: var(--color-warning-darker);
    --button-color-active: var(--color-warning-dark);
  }
.button-borderless.button-success {
    --button-color: var(--color-success);
    --button-color-active: var(--color-success-dark);
  }
.dark-bg .button-borderless {
  --button-bg-active: var(--white-02);
  --button-bg-hover: var(--white-01);
  --button-color: var(--white-06);
  --button-color-active: var(--white-09);
}
.button-error:is(.dark-bg .button-borderless) {
    --button-color: var(--color-error-lighter);
    --button-color-active: var(--color-error-light);
  }
.button-warning:is(.dark-bg .button-borderless) {
    --button-color: var(--color-warning);
    --button-color-active: var(--color-warning-light);
  }
.button-success:is(.dark-bg .button-borderless) {
    --button-color: var(--color-success);
    --button-color-active: var(--color-success-light);
  }
/* Link */
.button.button-link {
  --button-bg: transparent;
  --button-bg-active: var(--gray-02);
  --button-bg-hover: var(--gray-01);
  --button-color: var(--link-color);
  --button-color-active: var(--link-color);
  --button-padding: 2px;

  min-width: var(--button-size);
}
.dark-bg .button-link {
  --button-bg-active: var(--white-02);
  --button-bg-hover: var(--white-01);
  --button-color: var(--link-color-light);
}
/* Round */
.button.button-round {
  --button-size: 48px;
  --button-bg: var(--white-09);
  --button-bg-active: var(--gray-02-opaque);
  --button-bg-hover: var(--gray-01-opaque);
  --button-color: var(--primary-color);
  --button-color-active: var(--primary-color);
  --button-color-hover: var(--primary-color);

  border-radius: 50%;
  box-shadow: var(--default-box-shadow);
  min-width: 0;
  width: var(--button-size);
}
.button.button-round.button-s {
    --button-size: 36px;
  }
/* Rough draft, not ready for implementation */
.dark-bg .button-round {
  --button-bg: var(--gray-08);
  --button-bg-active: var(--gray-06-opaque);
  --button-bg-hover: var(--gray-07-opaque);

  /* --primary-color-light (now #85b5f0) is not defined yet */
  --button-color: #85b5f0;
  --button-color-active: #85b5f0;
  --button-color-hover: #85b5f0;
}
/*
 * We cannot easily remove these global variables, because they're used in multiple places.
 *
 * PLEASE DO NOT ADD MORE VARIABLES HERE! (Unless they're used in multiple places, too.)
 */
:root {
  --icon-size: 24px;
  --icon-size-xs: 16px;
}
:root {
  --default-font-icon-offset: -0.1; /* THEMING API */

  /* Use this variable for icons floating in text. */
  --floating-icon-transform: translateY(calc(var(--default-font-icon-offset)*1em));
}
.d-icon {
  --icon-color: currentColor;

  display: inline-block;
  flex-shrink: 0;
  height: var(--icon-size);
  margin: 0;
  vertical-align: middle;
  width: var(--icon-size);
}
:is(.d-icon path,.d-icon circle,.d-icon ellipse,.d-icon rect):where(:not([fill],[stroke])) {
      fill: var(--icon-color);
    }
.d-icon path:where([stroke]) {
    stroke: var(--icon-color);
    stroke-width: 1.5px;
  }
.d-icon.css-based-icon {
    background-color: var(--icon-color);

    /* noinspection CssUnresolvedCustomProperty */
    -webkit-mask-image: var(
      --mask-image
    );
            mask-image: var(
      --mask-image
    ); /* Variable --mask-image gets filled from icon.ts,
    that's why we ignore the rule CssUnresolvedCustomProperty here */
  }
.d-icon-xxs {
  --icon-size: 12px;
}
.d-icon-xs {
  --icon-size: var(--icon-size-xs);
}
.d-icon-s {
  --icon-size: 20px;
}
.d-icon-l {
  --icon-size: 32px;
}
.d-icon-xl {
  --icon-size: 48px;
}
.d-icon-light path {
  stroke-width: 1px;
}
.d-icon-bold path {
  stroke-width: 2px;
}
/*
 * The following classes use !important, because their only purpose is to change the icon color.
 * Without it, we had to special-case them in places where we also override the icon color.
 */
.d-icon-primary {
  color: var(--primary-color) !important;
}
.d-icon-error {
  color: var(--color-error) !important;
}
.d-icon-warning {
  color: var(--color-warning) !important;
}
.d-icon-stack {
  display: inline-block;
  height: var(--icon-size);
  position: relative;
  vertical-align: middle;
  width: var(--icon-size);
}
.d-icon-stack .d-icon {
    margin: 0;
    position: absolute;
  }
:is(.d-icon-stack .d-icon):not(.d-icon-badge) {
      left: 0;
    }
.d-icon-stack .d-icon-badge {
    bottom: -3px;
    height: 12px;
    right: -3px;
    width: 12px;
  }
.ellipsis {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.multiline-ellipsis {
  --ellipsis-lines: 3;

  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: var(--ellipsis-lines);
  overflow: hidden;
}
/**
 * Similar to .is-hover-visible, but elements are hidden in a way that they do not consume space in the layout.
 *
 * Note: This toggles between \`display: initial\` and \`display: none\`. Other values are currently not supported.
 *
 * Caution: This (intentionally) causes layout jank.
 * Use this utility only if required by the design, otherwise use .is-hover-visible.
 */
@media (hover: hover) {
    .is-hover-displayed:not(:is(.d-hover-context:is(:hover,.is-hover-active) .is-hover-displayed,:host(.d-hover-context:is(:hover,.is-hover-active)) .is-hover-displayed)) {
      display: var(--is-keynav, none);
    }
}
.d-icon.d-data-type-icon {
  color: var(--primary-color);
  vertical-align: bottom; /* To keep the height of the .d-attribute-tile to the height set above (16px) */
}
.d-icon.d-data-type-icon circle,.d-icon.d-data-type-icon ellipse,.d-icon.d-data-type-icon path,.d-icon.d-data-type-icon rect {
    fill: none !important;
  }
/*
 * Layout of this component:
 * +-------------------------------------+
 * | :host                               |
 * | +---------------------------------+ |
 * | | .main                           | |
 * | | +-----------------------------+ | |
 * | | | .main-label | .main-buttons | | |
 * | | +-----------------------------+ | |
 * | +---------------------------------+ |
 * | | .details                        | |
 * | +---------------------------------+ |
 * | | slot                            | |
 * | +---------------------------------+ |
 * +-------------------------------------+
 */
:host {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  justify-content: center;

  /* Without details, the tile's height should be 32px. */
  padding: calc(var(--space-2) - var(--border-width)) var(--space-2);
}
.main {
  display: flex;
  gap: var(--space-1);
  height: 16px;
}
.main-label {
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
}
.main-label .d-data-type-icon:last-of-type {
    margin-right: 2px;
  }
.main-buttons {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: var(--space-1);
}
.details {
  font-size: var(--small-font-size);
}
.details:empty {
    display: none;
  }
/*
 * We check the host not being empty, because atm we cannot check it for the slot itself:
 * https://github.com/w3c/csswg-drafts/issues/6867
 */
:host(:not(:empty)) .additional-details {
  display: block;
}
:host(.is-modified) .attribute-name {
  font-style: italic;
  padding-right: 2px; /* Required to not cut off some part of the italic characters which lean out of the container */
}
/* If locked, hide all buttons in the attribute tile except the info button.
 * If not locked, hide the lock-icon
 */
:host([locked]) .button:not(.d-attribute-tile--info-button),
:host(:not([locked])) .lock-icon {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/ui/button-variables.css","webpack://./src/ui/button/button.css","webpack://./src/ui/icon/icon-variables.css","webpack://./src/ui/icon/icon.css","webpack://./src/ui/ellipsis/ellipsis.css","webpack://./src/ui/utils/is-hover-displayed.css","webpack://./src/cadenza/workbook/attribute-element/data-type-icon.css","webpack://./src/cadenza/ui/attribute-tile/attribute-tile.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AAEA;EACE;IACE,qBAAqB;IACrB,qBAAqB;EACvB;AACF;ACbA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,sCAAsC;EACtC,iCAAiC;EACjC,8BAA8B;EAC9B,sCAAsC;EACtC,8CAA8C;;EAE9C,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,0BAA0B;EAC1B,oBAAoB;EACpB,cAAc;EACd,uCAAuC;EACvC,mCAAmC;EACnC,oCAAoC;EACpC,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB;;;mCAGiC;EACjC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB,EAAE,0CAA0C;AA8ChE;AA5CE;IACE,SAAS;EACX;AAEA;IACE,2CAA2C;IAC3C,mCAAmC;EACrC;AAEA;IACE,eAAe;EACjB;AAEA;IACE,wCAAwC;EAC1C;AAEA;IACE,kBAAkB;IAClB,kCAAkC;IAClC,sCAAsC;EACxC;AAME;MACE,yCAAyC;MACzC,iCAAiC;IACnC;AAGF;IACE,iBAAiB;EACnB;AAEA;IACE,eAAe;EACjB;AAEA;IACE,gBAAgB;EAClB;AAGF;EACE,4BAA4B;AAC9B;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,qCAAqC;EACrC,kCAAkC;EAClC,+BAA+B;EAC/B,2CAA2C;AAC7C;AAEA;;UAEU;AAEV,qBAAqB;AAErB;EACE,mCAAmC;EACnC,wBAAwB;EACxB,sBAAsB;;EAEtB,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAuC;EACvC,gCAAgC;AAQlC;AANE;IAGE,+BAA+B;IAC/B,8BAA8B;EAChC;AAGF;EACE,mCAAmC;EACnC,wBAAwB;EACxB,qBAAqB;AACvB;AAEA;EACE,mBAAmB;EACnB,2EAA2E;EAC3E,wBAAwB;EACxB,qBAAqB;;EAErB,iCAAiC;EACjC,kBAAkB;;EAElB,sFAAsF;AAaxF;AAZE;IACE,WAAW;IACX,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAClB,+BAA+B;EACjC;AAEA;AAlBF;IAmBI,mBAAmB;IACnB,wBAAwB;AAE5B;EADE;AAGF,gCAAgC;AAChC;EACE,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;AACvB;AAEA;;gBAEgB;AAEhB;EACE,qBAAqB;;EAErB,YAAY;EACZ,yBAAyB;AAa3B;AAXE;IACE,mBAAmB;EACrB;AAEA;IACE,qBAAqB;EACvB;AAEA;IACE,qBAAqB;EACvB;AAGF;;yBAEyB;AAEzB;EACE,4BAA4B;EAC5B,oCAAoC;AActC;AAZE;IACE,6CAA6C;IAC7C,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,2DAAgE;YAAhE,mDAAgE;IAChE,kCAAkC;EAKpC;AAHE;MACE,gBAAgB;IAClB;AAIJ;EACE,6DAA6D,EAAE,gCAAgC;AACjG;AAEA;;aAEa;AAEb,YAAY;AAEZ;EACE,iCAAiC;EACjC,kDAAkD;EAClD,oCAAoC;EACpC,iDAAiD;EACjD,+BAA+B;EAC/B,sCAAsC;EACtC,wCAAwC;AAC1C;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,qCAAqC;EACrC,kCAAkC;EAClC,qCAAqC;EACrC,2CAA2C;EAC3C,wCAAwC;AAC1C;AAEA,eAAe;AAEf;EACE,wBAAwB;EACxB,kCAAkC;EAClC,iCAAiC;EACjC,8BAA8B;EAC9B,2CAA2C;;EAE3C,6BAA6B;AAK/B;AAHE;IACE,qBAAqB;EACvB;AAGF;EACE,+BAA+B;AACjC;AAGE;IACE,kCAAkC;IAClC,8CAA8C;EAChD;AAEA;IACE,2CAA2C;IAC3C,gDAAgD;EAClD;AAEA;IACE,oCAAoC;IACpC,gDAAgD;EAClD;AAGF;EACE,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;AAgBxC;AAdE;IACE,0CAA0C;IAC1C,+CAA+C;EACjD;AAEA;IACE,oCAAoC;IACpC,iDAAiD;EACnD;AAEA;IACE,oCAAoC;IACpC,iDAAiD;EACnD;AAGF,SAAS;AAET;EACE,wBAAwB;EACxB,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;EACjC,wCAAwC;EACxC,qBAAqB;;EAErB,6BAA6B;AAC/B;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,uCAAuC;AACzC;AAEA,UAAU;AAEV;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,yCAAyC;EACzC,wCAAwC;EACxC,oCAAoC;EACpC,2CAA2C;EAC3C,0CAA0C;;EAE1C,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,yBAAyB;AAK3B;AAHE;IACE,mBAAmB;EACrB;AAGF,8CAA8C;AAC9C;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,wCAAwC;;EAExC,2DAA2D;EAC3D,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;AAC/B;ACtVA;;;;EAIE;AACF;EACE,iBAAiB;EACjB,oBAAoB;AACtB;ACNA;EACE,gCAAgC,EAAE,gBAAgB;;EAElD,kDAAkD;EAClD,gFAAkF;AACpF;AAEA;EACE,0BAA0B;;EAE1B,qBAAqB;EACrB,cAAc;EACd,wBAAwB;EACxB,SAAS;EACT,sBAAsB;EACtB,uBAAuB;AAyBzB;AAnBI;MACE,uBAAuB;IACzB;AAGF;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AAEA;IACE,mCAAmC;;IAEnC,6CAA6C;IAC7C;;KAEC;YAFD;;KAEC,EAAE;oEAC6D;EAClE;AAGF;EACE,iBAAiB;AACnB;AAEA;EACE,gCAAgC;AAClC;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;;;EAGE;AAEF;EACE,sCAAsC;AACxC;AAEA;EACE,oCAAoC;AACtC;AAEA;EACE,sCAAsC;AACxC;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AAiBzB;AAfE;IACE,SAAS;IACT,kBAAkB;EAKpB;AAHE;MACE,OAAO;IACT;AAGF;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;EACb;AC9GF;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AAEA;EACE,mBAAmB;;EAEnB,4BAA4B;EAC5B,oBAAoB;EACpB,yCAAyC;EACzC,gBAAgB;AAClB;ACdA;;;;;;;EAOE;AACF;IAEI;MAGE,+BAA+B;IACjC;AAEJ;AChBA;EACE,2BAA2B;EAC3B,sBAAsB,EAAE,+EAA+E;AAQzG;AANE;IAIE,qBAAqB;EACvB;ACHF;;;;;;;;;;;;;;;EAeE;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,uDAAuD;EACvD,kEAAkE;AACpE;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,YAAY;AAKd;AAHE;IACE,iBAAiB;EACnB;AAGF;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;AAEA;EACE,iCAAiC;AAKnC;AAHE;IACE,aAAa;EACf;AAGF;;;EAGE;AACF;EACE,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,kBAAkB,EAAE,+FAA+F;AACrH;AAEA;;EAEE;AACF;;EAEE,aAAa;AACf","sourcesContent":["/*\n * We cannot easily remove these global variables, because they're used in multiple places.\n *\n * PLEASE DO NOT ADD MORE VARIABLES HERE! (Unless they're used in multiple places, too.)\n */\n:root {\n  --button-size-m: 32px;\n  --button-size-s: 24px;\n}\n\n@media (--touch) {\n  :root {\n    --button-size-m: 44px;\n    --button-size-s: 32px;\n  }\n}\n","@import 'ui/button-variables.css';\n\n.button {\n  --button-bg: var(--gray-01);\n  --button-bg-active: var(--primary-color);\n  --button-bg-disabled: var(--button-bg);\n  --button-bg-hover: var(--gray-02);\n  --button-color: var(--gray-08);\n  --button-color-active: var(--white-09);\n  --button-color-disabled: var(--disabled-color);\n\n  align-items: center;\n  appearance: none;\n  background-color: var(--button-bg);\n  border: none;\n  color: var(--button-color);\n  display: inline-flex;\n  flex-shrink: 0;\n  font-family: var(--default-font-family);\n  font-size: var(--default-font-size);\n  font-weight: var(--bold-font-weight);\n  justify-content: center;\n  outline: none;\n  text-align: center;\n  text-decoration: none;\n  transition:\n    background-color var(--default-transition),\n    box-shadow var(--default-transition),\n    color var(--default-transition);\n  user-select: none;\n  white-space: nowrap;\n  width: fit-content; /* Do not stretch in column flex layouts */\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n\n  &:disabled {\n    background-color: var(--button-bg-disabled);\n    color: var(--button-color-disabled);\n  }\n\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: var(--button-bg-hover);\n  }\n\n  .is-keynav &:focus {\n    border-radius: 1px;\n    box-shadow: var(--default-outline);\n    outline: var(--default-native-outline);\n  }\n\n  &:active,\n  &.active,\n  &[aria-pressed='true'],\n  &[aria-expanded='true'] {\n    &:not(:disabled) {\n      background-color: var(--button-bg-active);\n      color: var(--button-color-active);\n    }\n  }\n\n  &:where(:not(.button-icon, .button-round)) > .d-icon:first-child {\n    margin-right: 2px;\n  }\n\n  & .button--label {\n    cursor: inherit;\n  }\n\n  & .button--label + .d-icon {\n    margin-left: 4px;\n  }\n}\n\n.light-bg .button {\n  --button-bg: var(--white-09);\n}\n\n.dark-bg .button {\n  --button-bg: var(--white-01);\n  --button-bg-active: var(--white-09);\n  --button-bg-disabled: var(--white-01);\n  --button-bg-hover: var(--white-02);\n  --button-color: var(--white-08);\n  --button-color-active: var(--primary-color);\n}\n\n/*********\n * Sizes *\n *********/\n\n/* Default Size (M) */\n\n.button {\n  --button-size: var(--button-size-m);\n  --button-icon-size: 24px;\n  --button-padding: 12px;\n\n  height: var(--button-size);\n  line-height: var(--button-size);\n  min-width: calc(var(--button-size) * 2);\n  padding: 0 var(--button-padding);\n\n  & > .d-icon,\n  & > .d-icon-stack,\n  & > .d-icon-stack > .d-icon {\n    height: var(--button-icon-size);\n    width: var(--button-icon-size);\n  }\n}\n\n.button-s {\n  --button-size: var(--button-size-s);\n  --button-icon-size: 20px;\n  --button-padding: 8px;\n}\n\n.button-xs {\n  --button-size: 20px;\n  --button-touch-size: calc(100% - var(--button-size) + var(--button-size-s));\n  --button-icon-size: 16px;\n  --button-padding: 4px;\n\n  font-size: var(--small-font-size);\n  position: relative;\n\n  /* increase the size of the button's touch target without increasing the visual size */\n  &::before {\n    content: '';\n    display: block;\n    height: var(--button-touch-size);\n    position: absolute;\n    width: var(--button-touch-size);\n  }\n\n  @media (--touch) {\n    --button-size: 24px;\n    --button-icon-size: 20px;\n  }\n}\n\n/* Not an official button size */\n.button-xxs {\n  --button-size: 16px;\n  --button-icon-size: 12px;\n  --button-padding: 2px;\n}\n\n/***************\n * Icon Button *\n ***************/\n\n.button-icon {\n  --button-padding: 4px;\n\n  min-width: 0;\n  width: var(--button-size);\n\n  &.button-s {\n    --button-padding: 0;\n  }\n\n  &.button-xs {\n    --button-padding: 1px;\n  }\n\n  &.button-xxs {\n    --button-padding: 2px;\n  }\n}\n\n/************************\n * Button with dropdown *\n ************************/\n\n.button-with-dropdown {\n  --dropdown-arrow-width: 12px;\n  --dropdown-arrow-color: currentColor;\n\n  &::after {\n    background-color: var(--dropdown-arrow-color);\n    content: '';\n    display: inline-block;\n    height: 24px;\n    mask-image: url('~@disy/cadenza-icons/dropdown-arrow-12x24.svg');\n    width: var(--dropdown-arrow-width);\n\n    :not(.button-icon)& {\n      margin-left: 4px;\n    }\n  }\n}\n\n.button-icon.button-with-dropdown {\n  width: calc(var(--button-size) + var(--dropdown-arrow-width)); /* Adds space for the dropdown */\n}\n\n/************\n * Variants *\n ************/\n\n/* Primary */\n\n.button.button-primary {\n  --button-bg: var(--primary-color);\n  --button-bg-active: var(--primary-color-darken-30);\n  --button-bg-disabled: var(--gray-03);\n  --button-bg-hover: var(--primary-color-darken-15);\n  --button-color: var(--white-09);\n  --button-color-active: var(--white-09);\n  --button-color-disabled: var(--white-07);\n}\n\n.light-bg .button-primary {\n  --button-color: var(--gray-01-opaque);\n  --button-color-disabled: var(--gray-01-opaque);\n}\n\n.dark-bg .button-primary {\n  --button-bg: var(--white-08);\n  --button-bg-active: var(--white-09);\n  --button-bg-disabled: var(--white-03);\n  --button-bg-hover: var(--white-09);\n  --button-color: var(--gray-08-opaque);\n  --button-color-active: var(--primary-color);\n  --button-color-disabled: var(--white-04);\n}\n\n/* Borderless */\n\n.button.button-borderless {\n  --button-bg: transparent;\n  --button-bg-active: var(--gray-02);\n  --button-bg-hover: var(--gray-01);\n  --button-color: var(--gray-06);\n  --button-color-active: var(--primary-color);\n\n  min-width: var(--button-size);\n\n  &:not(.button-icon) {\n    --button-padding: 2px;\n  }\n}\n\n.button-borderless.button-with-dropdown:not(:disabled) {\n  --dropdown-arrow-color: #6d7177;\n}\n\n.button-borderless {\n  &.button-error {\n    --button-color: var(--color-error);\n    --button-color-active: var(--color-error-dark);\n  }\n\n  &.button-warning {\n    --button-color: var(--color-warning-darker);\n    --button-color-active: var(--color-warning-dark);\n  }\n\n  &.button-success {\n    --button-color: var(--color-success);\n    --button-color-active: var(--color-success-dark);\n  }\n}\n\n.dark-bg .button-borderless {\n  --button-bg-active: var(--white-02);\n  --button-bg-hover: var(--white-01);\n  --button-color: var(--white-06);\n  --button-color-active: var(--white-09);\n\n  &.button-error {\n    --button-color: var(--color-error-lighter);\n    --button-color-active: var(--color-error-light);\n  }\n\n  &.button-warning {\n    --button-color: var(--color-warning);\n    --button-color-active: var(--color-warning-light);\n  }\n\n  &.button-success {\n    --button-color: var(--color-success);\n    --button-color-active: var(--color-success-light);\n  }\n}\n\n/* Link */\n\n.button.button-link {\n  --button-bg: transparent;\n  --button-bg-active: var(--gray-02);\n  --button-bg-hover: var(--gray-01);\n  --button-color: var(--link-color);\n  --button-color-active: var(--link-color);\n  --button-padding: 2px;\n\n  min-width: var(--button-size);\n}\n\n.dark-bg .button-link {\n  --button-bg-active: var(--white-02);\n  --button-bg-hover: var(--white-01);\n  --button-color: var(--link-color-light);\n}\n\n/* Round */\n\n.button.button-round {\n  --button-size: 48px;\n  --button-bg: var(--white-09);\n  --button-bg-active: var(--gray-02-opaque);\n  --button-bg-hover: var(--gray-01-opaque);\n  --button-color: var(--primary-color);\n  --button-color-active: var(--primary-color);\n  --button-color-hover: var(--primary-color);\n\n  border-radius: 50%;\n  box-shadow: var(--default-box-shadow);\n  min-width: 0;\n  width: var(--button-size);\n\n  &.button-s {\n    --button-size: 36px;\n  }\n}\n\n/* Rough draft, not ready for implementation */\n.dark-bg .button-round {\n  --button-bg: var(--gray-08);\n  --button-bg-active: var(--gray-06-opaque);\n  --button-bg-hover: var(--gray-07-opaque);\n\n  /* --primary-color-light (now #85b5f0) is not defined yet */\n  --button-color: #85b5f0;\n  --button-color-active: #85b5f0;\n  --button-color-hover: #85b5f0;\n}\n","/*\n * We cannot easily remove these global variables, because they're used in multiple places.\n *\n * PLEASE DO NOT ADD MORE VARIABLES HERE! (Unless they're used in multiple places, too.)\n */\n:root {\n  --icon-size: 24px;\n  --icon-size-xs: 16px;\n}\n","@import 'ui/icon/icon-variables.css';\n\n:root {\n  --default-font-icon-offset: -0.1; /* THEMING API */\n\n  /* Use this variable for icons floating in text. */\n  --floating-icon-transform: translateY(calc(var(--default-font-icon-offset) * 1em));\n}\n\n.d-icon {\n  --icon-color: currentColor;\n\n  display: inline-block;\n  flex-shrink: 0;\n  height: var(--icon-size);\n  margin: 0;\n  vertical-align: middle;\n  width: var(--icon-size);\n\n  & path,\n  & circle,\n  & ellipse,\n  & rect {\n    &:where(:not([fill], [stroke])) {\n      fill: var(--icon-color);\n    }\n  }\n\n  & path:where([stroke]) {\n    stroke: var(--icon-color);\n    stroke-width: 1.5px;\n  }\n\n  &.css-based-icon {\n    background-color: var(--icon-color);\n\n    /* noinspection CssUnresolvedCustomProperty */\n    mask-image: var(\n      --mask-image\n    ); /* Variable --mask-image gets filled from icon.ts,\n    that's why we ignore the rule CssUnresolvedCustomProperty here */\n  }\n}\n\n.d-icon-xxs {\n  --icon-size: 12px;\n}\n\n.d-icon-xs {\n  --icon-size: var(--icon-size-xs);\n}\n\n.d-icon-s {\n  --icon-size: 20px;\n}\n\n.d-icon-l {\n  --icon-size: 32px;\n}\n\n.d-icon-xl {\n  --icon-size: 48px;\n}\n\n.d-icon-light path {\n  stroke-width: 1px;\n}\n\n.d-icon-bold path {\n  stroke-width: 2px;\n}\n\n/*\n * The following classes use !important, because their only purpose is to change the icon color.\n * Without it, we had to special-case them in places where we also override the icon color.\n */\n\n.d-icon-primary {\n  color: var(--primary-color) !important;\n}\n\n.d-icon-error {\n  color: var(--color-error) !important;\n}\n\n.d-icon-warning {\n  color: var(--color-warning) !important;\n}\n\n.d-icon-stack {\n  display: inline-block;\n  height: var(--icon-size);\n  position: relative;\n  vertical-align: middle;\n  width: var(--icon-size);\n\n  & .d-icon {\n    margin: 0;\n    position: absolute;\n\n    &:not(.d-icon-badge) {\n      left: 0;\n    }\n  }\n\n  & .d-icon-badge {\n    bottom: -3px;\n    height: 12px;\n    right: -3px;\n    width: 12px;\n  }\n}\n",".ellipsis {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.multiline-ellipsis {\n  --ellipsis-lines: 3;\n\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: var(--ellipsis-lines);\n  overflow: hidden;\n}\n","/**\n * Similar to .is-hover-visible, but elements are hidden in a way that they do not consume space in the layout.\n *\n * Note: This toggles between `display: initial` and `display: none`. Other values are currently not supported.\n *\n * Caution: This (intentionally) causes layout jank.\n * Use this utility only if required by the design, otherwise use .is-hover-visible.\n */\n@media (--hover) {\n  .is-hover-displayed {\n    :not(\n        :is(.d-hover-context:is(:hover, .is-hover-active) &, :host(.d-hover-context:is(:hover, .is-hover-active)) &)\n      )& {\n      display: var(--is-keynav, none);\n    }\n  }\n}\n",".d-icon.d-data-type-icon {\n  color: var(--primary-color);\n  vertical-align: bottom; /* To keep the height of the .d-attribute-tile to the height set above (16px) */\n\n  & circle,\n  & ellipse,\n  & path,\n  & rect {\n    fill: none !important;\n  }\n}\n","@import 'ui/button/button.module.css';\n@import 'ui/icon/icon.module.css';\n@import 'ui/ellipsis/ellipsis.module.css';\n@import 'ui/utils/is-hover-displayed.css';\n@import 'cadenza/workbook/attribute-element/data-type-icon.module.css';\n\n/*\n * Layout of this component:\n * +-------------------------------------+\n * | :host                               |\n * | +---------------------------------+ |\n * | | .main                           | |\n * | | +-----------------------------+ | |\n * | | | .main-label | .main-buttons | | |\n * | | +-----------------------------+ | |\n * | +---------------------------------+ |\n * | | .details                        | |\n * | +---------------------------------+ |\n * | | slot                            | |\n * | +---------------------------------+ |\n * +-------------------------------------+\n */\n\n:host {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  justify-content: center;\n\n  /* Without details, the tile's height should be 32px. */\n  padding: calc(var(--space-2) - var(--border-width)) var(--space-2);\n}\n\n.main {\n  display: flex;\n  gap: var(--space-1);\n  height: 16px;\n}\n\n.main-label {\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0;\n\n  & .d-data-type-icon:last-of-type {\n    margin-right: 2px;\n  }\n}\n\n.main-buttons {\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  gap: var(--space-1);\n}\n\n.details {\n  font-size: var(--small-font-size);\n\n  &:empty {\n    display: none;\n  }\n}\n\n/*\n * We check the host not being empty, because atm we cannot check it for the slot itself:\n * https://github.com/w3c/csswg-drafts/issues/6867\n */\n:host(:not(:empty)) .additional-details {\n  display: block;\n}\n\n:host(.is-modified) .attribute-name {\n  font-style: italic;\n  padding-right: 2px; /* Required to not cut off some part of the italic characters which lean out of the container */\n}\n\n/* If locked, hide all buttons in the attribute tile except the info button.\n * If not locked, hide the lock-icon\n */\n:host([locked]) .button:not(.d-attribute-tile--info-button),\n:host(:not([locked])) .lock-icon {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
